import React from 'react';
import {interpolateRgb} from 'd3-interpolate';
import SimilarNeighborhoodsList from './SimilarNeighborhoodsList';
import DistributionGraph from './DistributionGraph';
import YearGraph from './YearGraph';

const NeighborhoodFocus2 = ({active_neighborhood, active_mode, active_price, active_year, active_probability, formatters, closeNeighborhoodFocus, neighborhoods, neighborhoods_samples, setActiveNeighborhood, interpolators}) => {

  const handleClose = () => {
    closeNeighborhoodFocus();
  }

  return (
    <div className="">
      <div className="px2">
        <div className='relative'>
          <div className="absolute right-0 top-0 h1 Closer" onClick={handleClose}>&times;</div>
        </div>
        <div className="h3 truncate" title={active_neighborhood.properties.neighborhood}>
          {active_neighborhood.properties.neighborhood}
        </div>
        <div className="capitalize">
          {active_neighborhood.properties.borough}
        </div>
        {active_mode ==='Chance' ? (
          <div
            className="p1 mt1 center"
            style={{background: interpolators.chance(active_neighborhood.properties.probability)}}
          >{formatters.percentFormat(active_neighborhood.properties.probability)}</div>
        ) : (
          <div
            className="p1 mt1 center"
          >{formatters.dollarShort(active_neighborhood.properties.price)}</div>
        )}
      </div>
    </div>
  )
}

export default NeighborhoodFocus2;


/** WEBPACK FOOTER **
 ** ./src/components/NeighborhoodFocus2.js
 **/